import { getCities, makeCitiesEndpoint } from '@src/service/cities'
import useSWR from 'swr'

export const useCities = (stateInitials?: string) => {
  const key = stateInitials ? makeCitiesEndpoint(stateInitials) : null

  return useSWR(key, () => getCities(stateInitials as string))
}
